export class WordChecker {
  constructor (word) {
    this.word = word
  }

  // 数字だけの入力か
  isNnum () {
    return this.word.match(/^[\d|０-９]*$/g) !== null
  }

  // 漢字だけの入力か
  isKanji () {
    const reg = /^([\u{3005}\u{3007}\u{303b}\u{3400}-\u{9FFF}\u{F900}-\u{FAFF}\u{20000}-\u{2FFFF}][\u{E0100}-\u{E01EF}\u{FE00}-\u{FE02}]?)+$/mu
    return this.word.match(reg) !== null
  }

  // 同じ文字を３文字以上連続した入力か
  isConsecutive () {
    return this.word.match(/^(.)\1{2,}/) !== null
  }
}
